import { createFileRoute, useSearch } from '@tanstack/react-router'

import { AgentBoardScreen } from './-components/agent-board-screen.tsx'

/** The Mob: every engineer's agents, for the office TV. */
export const Route = createFileRoute('/engineering/agent-board')({
  component: AgentBoardPage
})

function AgentBoardPage() {
  const search: Record<string, unknown> = useSearch({ strict: false })
  return <AgentBoardScreen view={search.view === 'pan' ? 'pan' : 'fit'} />
}
